export * from './queryKeys'

export const REQUEST_FORM_STATUS = ['active', 'inactive'] as const
